/** Stable empty array for selector fallbacks (avoids new [] reference every call). */
export const EMPTY_EMPLOYEE_IDS: Array<string> = []
